import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/manga';
import { useState, useEffect, useCallback } from 'react';

const heroTitles = [
  '番木瓜漫画 - 免费漫画全集阅读',
  '海量热门漫画，尽在番木瓜',
  '下拉式畅读，沉浸式体验',
];

export default function HeroSection() {
  const [currentTitle, setCurrentTitle] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const cycleTitle = useCallback(() => {
    setIsVisible(false);
    setTimeout(() => {
      setCurrentTitle((prev) => (prev + 1) % heroTitles.length);
      setIsVisible(true);
    }, 400);
  }, []);

  useEffect(() => {
    const interval = setInterval(cycleTitle, 4000);
    return () => clearInterval(interval);
  }, [cycleTitle]);

  const hotCount = mangaList.filter((m) => m.views > 10000000).length;
  const totalChapters = mangaList.reduce((sum, m) => sum + m.chapters, 0);

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=artistic%20abstract%20manga%20style%20background%20with%20warm%20orange%20red%20and%20deep%20brown%20gradient%20ink%20wash%20effect%2C%20subtle%20comic%20panel%20lines%2C%20dynamic%20energy%20flow%2C%20Japanese%20and%20Chinese%20fusion%20aesthetic%2C%20no%20characters%2C%20atmospheric%20gradient%20texture%2C%20dark%20edges%20with%20warm%20center%20glow&width=1600&height=900&seq=hero-bg-manga-01&orientation=landscape"
          alt="番木瓜漫画背景"
          className="w-full h-full object-cover"
          fetchpriority="high"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
          <i className="ri-sparkling-line text-accent-400 text-sm"></i>
          <span className="text-accent-300 text-xs font-medium">番木瓜漫画</span>
        </div>

        <h1
          className={`font-heading font-black text-3xl md:text-5xl lg:text-6xl text-background-50 mb-6 leading-tight transition-all duration-500 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          {heroTitles[currentTitle]}
        </h1>

        <p className="text-background-50/70 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          番木瓜漫画免费全集阅读专区，提供海量热门漫画的免费全集，支持下拉式阅读，
          在线免费看全集，漫画大全尽在番木瓜漫画。涵盖热血、恋爱、玄幻、搞笑、悬疑等多类型漫画。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/rexue"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-book-read-line text-base"></i>
            立即免费阅读
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/15 text-background-50 font-medium text-sm hover:bg-background-50/25 backdrop-blur-sm transition-all duration-200 whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-information-line text-base"></i>
            了解番木瓜
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-3 gap-4 max-w-lg mx-auto">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">
              {mangaList.length}+
            </div>
            <div className="text-xs text-background-50/60 mt-1">热门漫画</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
              {totalChapters.toLocaleString()}+
            </div>
            <div className="text-xs text-background-50/60 mt-1">漫画章节</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-secondary-300">
              {hotCount}+
            </div>
            <div className="text-xs text-background-50/60 mt-1">千万人气</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-5 h-8 rounded-full border-2 border-background-50/30 flex items-start justify-center">
          <div className="w-1 h-2 bg-background-50/50 rounded-full mt-1.5 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}